import { render, staticRenderFns } from "./purchaseHistory.vue?vue&type=template&id=e0b10484&scoped=true&"
import script from "./purchaseHistory.vue?vue&type=script&lang=js&"
export * from "./purchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./purchaseHistory.vue?vue&type=style&index=0&id=e0b10484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b10484",
  null
  
)

export default component.exports